require('lightgallery')

$(document).ready(function() {
    $("#lightgallery").lightGallery();

    $("#lightgallery2").lightGallery();

    $("#lightgallery-galeria").lightGallery(
        {
            selector: ".imagem-galeria",
            galleryId: 1,
            getCaptionFromTitleOrAlt: true,
            exThumbImage: 'data-exthumbimage'
        }
    );
});
